const it = {
    Italy: 'Italy',
    lisia: 'LISIA',
    loading: 'Loading',
    login: 'Login',
    cancel: 'Cancel',
    back: 'Back',
    close: 'Close',
    signup: 'Signup',    
    email: 'E-mail',
    password: 'Password',
    pick_a_password: 'Choose a Password',
    edit: 'Edit',
    delete:'Delete',
    remove: 'Remove',
    save: 'Save',
    submit: 'Submit',
    yes: 'Yes',
    no: 'No',
    ok: 'Ok',
    eur: '€',
    of_date: 'of',
    queries: 'queries',
    subscribe: 'Subscribe',
    back_to_profile: 'Go back to profile',
    back_to_login: 'Go back to login',
    back_to_site: 'Go back to site',
    go_to_login: 'Go to login',
    error: 'Error',
    something_is_wrong: 'Something is wrong',
    all_ok: 'Informazioni',
    update_successful: 'Successfully updated',
    add_card: 'Add card',
    day: 'day',
    days: 'days',
    month: 'month',
    months: 'months',
    then: 'then',
    year: 'year',
    daily: 'Daily',
    monthly: 'Monthly',
    annual: 'Annual',
    forever: 'forever',
    once: 'once',
    optional: 'Opzionale',
    //todo remove
    giornaliero: 'Daily',
    mensile: 'Monthly',
    annuale: 'Annual',
    plan: 'Plan',
    current: 'Current',
    expiration: 'Expiration',
    over: 'over',
    available_soon: 'Available soon',
    credit_card_number: 'Card Number',
    user_enabled: 'Enabled',
    user_disabled: 'Disabled',
    user_email_verified: 'Email verified',
    user_email_not_verified: 'Email not verified',
    go_to_app: 'Go back to the app',
    generic_fail_message: 'Something went wrong!',
    restore_password: 'Restore password',
    search_ask_me_something: 'Ask Lisia',
    sidebar_home: 'Home',
    sidebar_profile: 'Profile',
    sidebar_history: 'History',
    sidebar_directories: 'Folders',
    sidebar_subscription: 'Subscription',
    sidebar_admin_panel: 'Administration Panel',
    sidebar_logout: 'Log-out',
    sidebar_menu: 'Menu',
    history_title: 'Search history',
    history_search_placeholder: 'Query search history',
    history_order: 'Date order',
    history_order_asc: 'ascending',  
    history_order_desc: 'descending',
    history_search_again: 'Search again',
    history_date: 'Date',  
    history_all_time: 'All time',
    history_last_7_days: 'Last 7 days',
    history_last_month: 'Last month',
    history_query: 'Query',
    history_query_type: 'Document type',
    type_principle: 'Principle',
    type_verdict: 'Verdict',
    folder: 'Folder',
    folder_name: 'Folder Name',
    folder_created: 'was created successfully',
    folder_description: 'The description of folder',
    folder_description_modified: 'was modified',
    folder_deleted: 'was deleted',
    folders_title: 'Your folder list',
    folders_create_new_folder: 'Create new folder',
    folders_creation_date: 'Creation date',
    folders_last_edit_date: 'Last Modified',
    folders_delete_title: 'Delete Folder',
    folders_delete_message_prefix: 'Are you sure you want to delete the folder',
    folders_delete_message_suffix: 'and all its content?',
    folder_element_deleted: 'The item was removed from the folder',
    folder_name_exists: 'A folder with the same name exists already',
    folders_description: 'Description...',
    folders_search: 'Search folder',
    user_delete_header: 'Delete User',
    user_delete_message: 'Are you sure you want to delete the user?',
    subscription_title: 'Your subscription',
    subscription_admin_alert: 'You are Logged In as Administrator',
    subscription_trial_alert: 'You have a trial period, after the trial period your plan will be:',
    july_2020_subscription_annual_plan: 'Premium Annual (30 days trial)',
    july_2020_subscription_monthly_plan: 'Premium Monthly (30 days trial)',
    july_2020_subscription_trial_plan: 'Free Basic Evaluation',
    subscription_monthly_plan: 'Monthly plan',
    subscription_annual_plan: 'Annual plan',
    subscription_daily_plan: 'Daily plan',
    subscription_trial_plan: 'Evaluate Lisia',
    subscription_payment_method_title: 'Payment method',
    subscription_payment_method_description_prefix: 'You used the',
    subscription_payment_method_description_suffix: 'card that ends with',
    subscription_update_payment_method: 'Update payment method',
    subscription_payment_method_missing: 'Your didn\'t provide any payment methods',
    subscription_update_payment_method_description: 'Updating your payment method won\'t change or extend your plan.',
    subscription_update_payment_method_description_prefix: 'You will still pay',
    subscription_update_payment_method_description_suffix: 'each',
    subscription_payment_intro_returning: 'Select a valid payment method',
    subscription_payment_intro: 'Select a payment method',
    subscription_payment_intro_continued: ' and start your free trial',
    subscription_payment_intro_2: 'No payment until the trial period expires',
    subscription_payment_intro_3: 'Unsubscribe at any time',
    subscription_payment_intro_3_continued: 'Unsubscribe at any time',
    subscription_payment_method: 'Credit or Debit card',
    subscription_payment_pci_compliance: 'PCI-compliant data security',
    subscription_payment_cancellation: 'You can cancel at any time by going to the subscription section of your profile',
    subscription_plan_title_prefix: '',
    subscription_plan_title_suffix: 'Plan',
    subscription_plan_udated: 'Subscription plan updated',
    subscription_plan_udate_fail: 'Subscription plan update failed',
    subscription_activation_message_prefix: 'You have a trial period that will end on',
    subscription_activation_message_suffix: 'after that date your paid account will be activated',
    subscription_renew_message_prefix: 'Your subscription will be automatically renewd on',
    subscription_renew_message_suffix: ', you will be charged of',
    subscription_query_count_message_prefix: 'You performed',
    subscription_query_count_message_suffix: 'queries of',
    subscription_queries_left_description_prefix: 'You still have',
    subscription_queries_left_description_suffix: 'queries this month, any query exceeding the maximum queries count will cost you 0.05€.',
    subscription_queries_over_prefix: 'you consumed all',
    subscription_queries_over_suffix: 'your queries this month. You also performed',
    subscription_additional_queries_description :'more queries costing 0.05€ each.',
    subscription_expired: 'Your subscription has expired',
    subscription_no_queries: 'You have exceeded the number of requests this month',
    subscription_add: 'Add a new subscription',
    subscription_manage: 'Manage subscription',
    subscription_manage_body: 'Manage your subscription in the relatise website section or clicking on the button below',
    subscription_manage_alert_body: 'You won\'t be able to perform searches until you activate your subscription',
    subscription_cancellation_success_header: 'Cancellation succeeded',
    subscription_cancellation_success_message: 'Your subscription was successfully cancelled',
    subscription_cancellation_fail_message: 'We couldn\'t cancel your subscription',
    subscription_edit_or_cancel: 'Edit or delete',
    subscription_change: 'Change',
    subscription_change_plan: 'Change your plan',
    subscription_change_plan_description: 'Clicking on "Subscribe" we\'ll ask you a confirmation. By accepting you will move to the new plan and you will be charged by the cost of the new plan, the renw date will be moved to the expire date of the new plan period from now',
    subscription_enterprise_plan_title: 'Enterprise Plan',
    subscription_enterprise_plan_subtitle: 'A plan that meets your requirements',
    subscription_enterprise_plan_description: 'A plan designed to specifically meet your requirements.',
    subscription_enterprise_contact_us: 'For info, contact us',
    subscription_periodic_plan_active_description_prefix: 'This plan lets you perform ',
    subscription_periodic_plan_description_prefix: 'This plan would let you perform',    
    subscription_periodic_plan_description_suffix: ' queries each ',
    subscription_periodic_plan_active: 'You are currently subscribet to this plan',
    subscription_delete_your_account: 'Delete your account',
    subscription_payment_method_updated: 'Payment method updated',
    subscription_payment_method_update_fail: 'We couldn\'t update your payment method',
    subscription_payment_list_title: 'Payments history',
    subscription_paid_amount: 'Paid amount',
    subscription_amount_due: 'Amount due',
    subscription_payment_date: 'Payment Date',
    subscription_download_invoice: 'Download invoice',
    subscription_trial_disclamer: 'You\'ll have a trial period of ${days} days, at the end of the trial you will be charged of ${interval} subscription cost',
    subscription_trial_disclamer_capital: 'FREE ${days} DAYS TRIAL',
    subscription_trial_admin_disclamer: 'Including a trial period of ${days} days',
    subscription_trial_offer: 'A limited one-time offer:',
    subscription_expires_after: 'expires after',
    subscription_expires_on: 'Will Expires on',
    subscription_one_time_offer: 'This is a one-time offer it won\'t automatically renew',
    subscription_renews_on_expiration: 'The subscription will automatically renew each ${interval}',
    subscription_will_renew_on: 'Will renew on',
    subscription_will_expire_on:'Will expire on',
    subscription_free_deactivation: 'You will be able to easily cancel the automatic renewal before the trial ends,',
    subscription_renews_on_trial_expiration: 'otherwise the subscription will automatically renew each ${interval}',
    subscription_wont_renew_on_expiration: 'The subscription won\'t renew upon expiration',
    subscription_no_plan: 'You didn\'t subscribe to any plan',
    subscription_update_plan_confirm : 'Do you want to update your plan?',
    subscription_license_will_expire_on : 'Your license will expire on',
    subscription_coupon_period_prefix: 'for the first ',
    subscription_coupon_redeem_by: 'Valid until',
    subscription_coupon_valid_until: 'until',
    subscription_will_be_paid_on: 'The cost of the subscription will be charged on:',
    subscription_plan_change_description: 'You are about to subscribe to the following plan:',
    subscription_cancel_renewal: 'Cancel renewal',
    subscription_restore_renewal: 'Restore renewal',
    subscription_cancel_renewal_confirm: ' do you really want to cancel renewal?',
    subscription_cancel_renewal_confirm_details: 'By canceling your subscription you won\'t be able to perform searches when reaching the expiration date. Your account will still be maintained, and you\'ll be able to renew your subscription at any time!',
    subscription_active: 'Active',
    subscription_not_active: 'Not Active',
    subscription_default_plan_title: 'After ${days} days you will pay ${discount_price}${currency}/Month instead of ',
    subscription_default_description_item_1: 'Unlimited queries',
    subscription_default_description_item_2: 'Login from desktop and mobile',
    subscription_default_description_item_3: 'Weekly updates',
    subscription_default_description_item_4: 'Manage and organize your queries',
    subscription_default_description_item_5: '12 hour customer care',
    invoice_heading_prefix: '',
    invoice_heading_suffix: '',
    invoice_paid: 'Paid',
    invoice_payment_failed: 'Payment failed',
    invoice_payment_succeeded: 'Payment succeeded',
    invoice_due: 'Not Paid',
    invoice_voided: 'Canceled',
    do_you_hate_us : ', do you want to delete your account?',
    you_still_have_time: 'You still have time before your',
    your_trial: 'trial',
    your_subscription: 'subscription',
    expires: 'expires',
    tell_us_your_problems: 'Contact us on the chat and talk about your troubles, we will work out a solution together.',
    help_us: '',
    user_profile_your_profile: 'Your Profile',
    user_profile_user_profile: 'User Profile',
    user_profile_first_name: 'Name',
    user_profile_last_name: 'Surname',
    user_profile_email: 'Email',
    user_profile_queries: 'Queries',
    user_profile_paid_account: 'Paid Subscription',
    user_profile_license_expiration: 'License Expiration',
    user_profile_registration_date: 'Registration Date',
    user_profile_actions: 'Actions',
    user_profile_refresh_queries: 'Refresh queries',
    user_profile_add_queries: 'Add queries',
    user_profile_reset_queries: 'Reset queries',
    user_profile_edit_profile: 'Edit user',
    user_profile_delete_user: 'Delete user',
    user_profile_show_payment_methods: 'Show payment methods',
    user_profile_payment_methods: 'Payment method',
    user_profile_show_billing_info: 'Show billing info',
    user_profile_billing_info: 'Billing info',
    user_profile_created: 'User profile created',
    user_profile_updated: 'User profile updated',
    user_profile_update_failed: 'We couldn\'t update your profile, check the data and retry',
    user_profile_deleted: 'User profile deleted',
    user_profile_load_error: 'Something went wrong fetching user information',
    user_profile_we_need_some_info: 'We need some more additional informations',
    user_profile_invoice_settings_info: 'In order to correctly crete tour invoices wee ned you to specify some additional informations, please go to your profile and add the missing information in the invoice settings',
    with_subscription: 'With subscription',
    add_user: 'Add new user',
    signup_account_information: 'Account information',
    signup_i_am_a_lawyer: 'I am a lawyer',
    signup_i_declare_that: 'Work',
    signup_i_am_a_lawyer_of_rome: 'Sono un avvocato registrato all\'ordine degli avvocati di roma',
    signup_i_accept_terms: 'I accept the',
    signup_i_accept_terms_anchor: 'terms of use',
    signup_plan_type: 'Plan type',
    signup_trial_disclamer: 'You will be given the 10 days of trial',
    signup_name_is_required: 'Name is a required field.',
    signup_surname_is_required: 'Surname is a required field.',
    signup_email_is_required: 'Email is a required field.',
    signup_email_is_invalid: 'Email is not valid.',
    signup_plan_is_required: 'Choose a plan.',
    signup_password_is_required: 'The password is required',
    signup_lawyer_type_is_required: 'Select an option',
    signup_terms_required: 'You must accept terms and conditions',
    signup_queries_must_be_positive: 'Queries must be 0 or a positive number',
    signup_payment_method_is_required: 'A payment method is required',
    signup_card_requires_plan: 'Users with a card must have a plan',
    signup_success: 'Signup succeeded, redirecting you to the login page',
    signup_failed: 'Signup failed, please try again later...',
    signup_payment_authentication_failed: 'To proceeed with the registration you must authenticate your paymentmethod',
    signup_success_payment_authentication_failed: 'Go to the subscription section to solve problems with your payments',
    signup_success_no_pwd: 'Signup succeeded, check your email inbox for login info, redirecting you to the login page',
    signup_success_panel_title: 'Verification email sent!',
    signup_success_panel_body: 'We sent you an email to verify tour address',
    signup_success_alert_body: 'Please check your spam folder.',
    signup_warning_message: 'Complete your registration',
    signup_select_an_option: 'Select an option',
    signup_card_auth_descriptor: 'LISIA - Subscription',
    signup_integration_panel_title: 'complete your registration',
    signup_integration_panel_title_2: ' complete your registration!',   
    signup_integration_panel_subtitle: 'Select the plan to use when trial period expires',
    signup_integration_panel_subtitle_2: 'Your card will not be charged up to the end of the free trial',
    signup_integration_panel_subtitle_3: 'Just after ${days} days you\'ll start paying ${price}${currency} / ${interval}',
    signup_integration_panel_subtitle_4: ' you will be able to cancel the automatic renewal from tour subscription panel',
    signup_integration_panel_subtitle_5: 'Yu will have access to:',
    signup_your_plan_will_be: 'Your plan will be:',
    signup_change_plan_description: 'Choose the plan you desire',
    signup_change_plan_description_free: 'free for ${days} giorni.',
    send_verification_email_panel_title: 'Verification email sent!',
    send_verification_email_panel_body: 'Verification email sent to ${email}. Click on the link contained in the email to verify your address!',
    send_verification_email_alert_body: 'Please check your spam folder.',
    new_verification_email_sent: 'New verification email sent',
    verification_email_failed: 'We couldn\'t send you a new verification email',
    plans_load_failed: 'We couldn\'t load plans details, try again later',
    restore_password_description: 'Insert the email of the account you want to restore',
    restore_password_instructions: 'Instructions to restore the password will be sent to the email address',
    restore_password_send: 'Restore password',
    change_password_description: 'Insert the new password',
    change_password_button: 'Change password',    
    update_password: 'Update password',
    insert_old_password: 'Old password',
    insert_new_password: 'New password',
    confirm_new_password: 'Confirm new password',
    repeat_new_password: 'Repeat new password',
    passwords_dont_match: 'The password don\'t match',
    old_password_is_required: 'The old password is required',
    new_password_is_required: 'The new password is required',
    repeat_password_is_required: 'The repeat password field is required',
    admin_usesr_profile_verified_email: 'Email status',
    admin_users_all: 'All',
    admin_users_disabled: 'Disabled',
    admin_users_enabled: 'Enabled',
    admin_users_email_verified: 'With verified email',
    admin_users_email_not_verified: 'Without verified email',
    admin_users_search: 'Search...',
    admin_user_queries: 'Queries',
    admin_user_enabled: 'Enabled',
    admin_user_disabled: 'Disabled',
    admin_user_profile_email: 'Email',
    admin_user_profile_first_name: 'Name',
    admin_user_profile_last_name: 'Surname',
    server_error_login: 'The request requires an access token, please log in',
    server_error_wrong_data: 'The username or password are wrong',
    server_error_user_not_exists: 'The username does not exist',
    server_error_account_disabled: 'Your account has been disabled',
    server_error_missing_data: 'Some required parameters are missing',
    server_error_wrong_email_format: 'Wrong email format',
    server_error_wrong_password_format: 'The password must be at least six characters long',
    server_error_used_email: 'Email used already',
    server_error_token_updated: 'Token updated',
    server_error_token_valid: 'Token still valid',
    server_error_token_not_valid: 'Token invalid',
    server_error_token_expired: 'The session expired, please login again',
    server_error_email_not_found: 'Email not found',
    server_message_password_email_sent: 'We sent you an email with the new password',
    server_message_recovery_email_sent: 'We sent you an email with the instruction to change your password',
    server_error_invalid_code: 'Invalid code',
    server_error_file_not_found: 'File not found',
    server_error_userame_is_empty: 'The username can\'t be empty',
    server_error_error_updating: 'Ops looks like we got an error during the update',
    server_error_user_not_found: 'Ops looks like we do not have any user with this id',
    server_error_wrong_old_password:  'Your old password doesn\'t match',
    server_error_missing_params:  'Missing required parameters',
    server_error_account_expired: 'We are sorry but your account expired',
    server_error_another_session_open: 'You logged in from another davice, your session was closed',
    server_error_password_changed_already: 'The link you used is not valid anymore, please ask for a new password recovery',
    server_message_password_successfully_changed: 'Password successfully updated',
    server_error_internal_server_error: 'Unknown Error',
    server_error_email_exist: 'Email in use',
    server_message_password_updated: 'Password updated',
    search_area_court: 'Supreme Court',
    search_area_tribunals: 'Tribunals',
    search_type_verdict: 'Verdict',
    search_type_rule: 'Rule',
    search_filter_pures_heading: 'Authoral Principles',
    search_filter_all: 'All',
    search_filter_law: 'Law',
    search_filter_regulations: 'Regulation',
    search_filter_codes: 'Commented Codes',
    search_filter_doctrine: 'Doctrine',
    search_filter_in_depth: 'In depth',
    search_rule_heading: 'RULE',
    search_synthetic_rule_heading: 'EXTRACT',
    search_access_denied: 'Access denied',
    search_access_from_two_devices: 'You logged in fromtwo devices',
    search_login_again_to_search: 'You have to login again to use the system',
    search_no_results: 'We are sorry but we didn\'t find any result',
    search_search_rules: 'Search for rules',
    search_search_verdicts: 'Search for verdicts',
    search_reset_filters: 'Click on this button to reset search filters',
    search_reset_filters_button: 'Reset filters',
    search_filters_title: 'Filter results',
    search_authority: 'Authority',
    search_filters_authority: 'Filter by authority',
    search_year: 'Year',
    search_filters_year: 'Filter by year',
    search_filter_button: 'Filter',
    search_load_more: 'Load More',
    search_folder_exists: 'A folder with the same name exists already',
    search_response_heading: 'ANSWER',
    search_search_rules_popup: 'Lisia will search authoral principles',
    search_search_synthetic_popup: 'Lisia will search in verdict\'s text and will extract relevant text for you',
    result_components: 'Components',
    result_feedback_positive: 'Positive',
    result_verdict_number: 'verdict number',
    result_verdict: 'verdict',
    result_full_document: 'Full document',
    result_full_verdict: 'Full verdict',
    result_full_verdict_capital: 'FULL VERDICT',
    result_saved_heading: 'Result saved',
    result_saved_description: 'The result was saved in the folder',
    result_folder_description_heading: 'Add a description to the folder',
    result_folder_description: 'Insert folder description here...',
    result_add_to_existing: 'Add to an existing folder or create a new one',
    result_folder_name_limit_exceeded: 'The length of a folder name can\'t exceed 50 chars, the name will be truncated to 50 chars',
    result_folder_select: 'Select a folder',
    result_folder_create: 'Create folder',
    result_folder_remove_item: 'Click on this icon to remove the element from the folder',
    result_negative_feedback_description: 'Tell us what\'s wrong with this answer',    
    result_positive_feedback_description: 'Upvote this result if you think it\'s fitting the query, you\'ll help us give better responses in future',
    result_feedback_saved: 'Feedback saved',
    result_feedback_thanks: 'Thanks for your feedback!',
    result_of_city: ' of ',
    result_tribunal_of: 'Tribunal of',
    result_court_of_appeal_of: 'Court of appeal of',
    result_supreme_court: 'Supreme Court',
    result_issuer_judge: 'Judge',
    result_freedom_tribunal: 'Freedom tribunal',
    result_minors_tribunal: 'Minors tribunal',
    result_tar: 'TAR',
    result_state_council: 'State council',
    result_ctp: 'CTP',
    result_ctr: 'CTR',
    result_cga: 'CGA',
    result_section: 'section',
    result_section_capital: 'Section',
    result_first: 'First',
    result_second: 'Second',
    result_third: 'Third',
    result_fourth: 'Fourth',
    result_fifth: 'Fifth',
    result_sixth: 'Sixth',
    result_seventh: 'Seventh',
    result_eighth: 'Eighth',
    result_ninth: 'Ninth',
    result_civil: 'civil',
    result_penal: 'penal',
    result_administrative: 'administrative',
    result_tributary: 'tributary',
    result_work: 'work',
    result_minors: 'minors',
    result_family: 'family',
    result_is_pure_heading: 'Ruling',
    result_is_synthetic_heading: 'Extracted by Lisia',
    result_is_synthetic: 'This result is synthetic',
    result_close_and_go_up: 'Close and go up',
    result_click_to_highlight_in_text: 'Click on the text to go see the extracted part in the full verdict',
    email_in_use: 'Email in use',
    email_was_in_use: 'Your email is already in our system, you cannot purchase this offer',
    verify_email_title: 'Email Verification',
    verify_email_description: 'Before you can access LISIA you need to verify your email address, you should have received an email at the address displayed below, click on the link in the email to verify your address',
    no_email_received: 'I didn\'t receive any email',
    user_was_registered: 'This email was used by a user that has been deleted',  
    verification_email_sent: 'We sent you a new verification email',  
    email_verified: 'Email Verified! Redirecting to login...',
    lawyer_check_text: 'lawyer declaration',
    therms_and_conditions_title: 'Therms and conditions',
    therms_and_conditions: 'Therms and conditions',
    add_billing_info: 'Add billing info',
    billing_info_invoice_type: 'Invoice type',
    billing_info_invoice_type_receipt: 'Receipt',
    billing_info_invoice_type_invoice: 'Invoice',
    billing_info_title: 'Invoicing informations',
    billing_info_address: 'Address',
    billing_info_address_placeholder: 'Address',
    billing_info_address_complement: 'Stairs, floor, (Optional)',
    billing_info_zip_code: 'Zip code',
    billing_info_city: 'City',
    billing_info_state: 'State',
    billing_info_country: 'Country',
    billing_info_vat_number: 'Vat Number',
    billing_info_fiscal_code: 'Fiscal Code',
    billing_info_fe_code: 'Recipient code',
    billing_info_pec: 'PEC Adress',
    billing_info_fe_code_or_pec: 'Recipient code or Indirizzo Posta Elettronica Certificata',
    billing_info_pec_or_code_required: 'You must insert a PEC Adress',
    billing_info_address_required: 'You must insert an address',
    billing_info_vat_number_required: 'You must insert a vat number',
    billing_info_fiscal_code_required: 'You must insert a fiscal code',
    billing_info_vat_or_fc_required: 'You must insert a fiscal code or vat number',
    billing_info_check: 'Check the billing infos',
    tax_id_invalid: 'Your Vat number is invalid',
    billing_info_fiscal_code_format_invalid: 'Your Fiscal code is invalid',
    resource_missing: 'No payment method found'
  };
  
  export default it;